import React, { useState } from 'react';
import { useTranslation } from '../../hooks/useTranslation';
import { authFetch } from '../../utils/auth';

const EditCollectionPopup = ({ collection, onClose, onCollectionUpdated }) => {
  const [title, setTitle] = useState(collection.title);
  const [description, setDescription] = useState(collection.description);
  const { t } = useTranslation();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await authFetch(`/collections/${collection._id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ title, description }),
      });

      if (response.ok) {
        const updatedCollection = await response.json();
        onCollectionUpdated(updatedCollection);
        onClose();
      } else {
        console.error('Failed to update collection');
      }
    } catch (error) {
      console.error('Error updating collection:', error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-20 bg-backdrop/70 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-[#FCFCF9] shadow-md p-10 rounded-lg max-w-md w-full relative z-60">
        <h2 className="text-xl font-semibold mb-4">{t('editCollectionPopup.title')}</h2>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder={t('editCollectionPopup.namePlaceholder')}
            className="w-full p-2 mb-4 border rounded"
          />
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder={t('editCollectionPopup.descriptionPlaceholder')}
            className="w-full p-2 mb-4 border rounded"
          />
          <div className="flex justify-end">
            <button type="button" onClick={onClose} className="mr-2 px-4 py-2 bg-gray-200 rounded">
              {t('editCollectionPopup.cancel')}
            </button>
            <button type="submit" className="px-4 py-2 bg-[#E79469] text-[#1E1A1A] rounded">
              {t('editCollectionPopup.update')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EditCollectionPopup;
